import type { FC, ReactNode } from "react";
import PropTypes from "prop-types";
import Forbidden from "../pages/Forbidden";
import { usePermissions } from "src/hooks/usePermissions";

interface TemplateGuardProps {
  children: ReactNode;
}

const MessagingFlowsGuard: FC<TemplateGuardProps> = ({ children }) => {
  const { textFlowsEnabled } = usePermissions();

  if (!textFlowsEnabled) {
    return <Forbidden />;
  }

  return <>{children}</>;
};

MessagingFlowsGuard.propTypes = {
  children: PropTypes.node,
};

export default MessagingFlowsGuard;
